import { apiAgent } from "@/network/axiosAgent";
import { asyncTaskCancel, asyncTaskResult } from "@/network/network.jsx";
import { unwrapAsyncTaskResultBody } from "@/modern/components/async-tasks/utils";
import type {
  CancelNotificationTaskResponse,
  MarkAllNotificationsSeenRequest,
  MarkAllNotificationsSeenResponse,
  MarkNotificationSeenResponse,
  NotificationCountParams,
  NotificationCountsResponse,
  NotificationListParams,
  NotificationListResponse,
  NotificationService,
  NotificationTaskResult,
} from "../types";

export const notificationsService: NotificationService = {
  async list(params: NotificationListParams): Promise<NotificationListResponse> {
    const { data } = await apiAgent.get<NotificationListResponse>("/notify/inbox", { params });
    return data;
  },

  async counts(params: NotificationCountParams): Promise<NotificationCountsResponse> {
    const { data } = await apiAgent.get<NotificationCountsResponse>("/notify/counts", { params });
    return data;
  },

  async markSeen(id: number, isSeen: boolean): Promise<MarkNotificationSeenResponse> {
    const { data } = await apiAgent.patch<MarkNotificationSeenResponse>(
      `/notify/inbox/${id}/seen`,
      { is_seen: isSeen },
    );
    return data;
  },

  async markAllSeen(filters: MarkAllNotificationsSeenRequest): Promise<MarkAllNotificationsSeenResponse> {
    const { data } = await apiAgent.post<MarkAllNotificationsSeenResponse>(
      "/notify/inbox/mark-all-seen",
      filters,
    );
    return data;
  },

  async cancelTask(asyncTaskId: number): Promise<CancelNotificationTaskResponse> {
    const { data } = await asyncTaskCancel(asyncTaskId);
    return data as CancelNotificationTaskResponse;
  },

  async getResult(asyncTaskId: number): Promise<NotificationTaskResult> {
    // Same route as Import editor / async-task polling — not /notify/inbox/tasks/...
    const { data } = await asyncTaskResult(asyncTaskId);
    return unwrapAsyncTaskResultBody(data) as NotificationTaskResult;
  },
};
